import { environment } from '../../environments/environment';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, Renderer2, ViewChild } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import 'rxjs/add/operator/map';
import { NgxSiemaOptions, NgxSiemaService  } from 'ngx-siema';

import { HttpClient } from '@angular/common/http';

import { NotificationsService } from 'angular4-notifications';

import { addHourToDatePipe } from '../pipes/addHourToDate.pipe';

declare let gtag: Function;
import * as moment from 'moment';
import { Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.css'],
})

export class GameComponent implements OnInit {

	gameId = 119;
	game: any = {};
  doAnimate: boolean = false;
  score: any = {};
  playerClics: any = {};
  highScore = 0;
  scores: any = {};
  resultRecord: any= {};
  gameLastScores: any = {};
  position: any = '-' ;

  previousHighScore = 0;

  countDownText:any = {
    Year: 'A',
    Month: 'm',
    Weeks: "S",
    Days: "j",
    Hours: "h",
    Minutes: "m",
    Seconds: "s",
    MilliSeconds: "Ms"
  };


  myCollection = [];
  collectionWithSiemaOptions = [];

  now: any;

  maxNbClicPerHour = 100;
  endNbClicHour: any;

  userId = '1';
  userRole = 'ROLE_USER';
  username = 'odecharette';

  apiEndPoint: string;

  siemaOptions: any = {
   selector: `.siema_x`,
   duration: 200,
   easing: 'ease-out',
   perPage: 1,
   startIndex: 0,
   draggable: true,
   threshold: 20,
   loop: true
 }

 playerLastScores: any = [];
 nbClics: number = 1;

  @ViewChild('scoresQueue') scoresQueue: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute, 
    private http: HttpClient, 
    private ngxSiemaService: NgxSiemaService,
    private notificationService: NotificationsService,
    private metaService: Meta,
    private renderer: Renderer2) { 

    setInterval(() => {
        this.now = moment();
     }, 1000);
  }

  ngOnInit() {
    this.apiEndPoint = environment.symfonyEndpointSecuredForUser;
    this.highScore = 874263;
    this.playerLastScores.push(this.highScore);
    this.scores = this.playerLastScores; 
  }

  prevSlide(id) {
    this.ngxSiemaService.prev(1, '.siema_' + id).subscribe();
  }

  nextSlide(id) {
    this.ngxSiemaService.next(1, '.siema_'+ id).subscribe();
  }

  // Called by click on Big Button in game.component.html
  getScore(){

      this.http.get(this.apiEndPoint + environment.apiGetScore).map((res: Response) => res).subscribe(score => {
        this.score = score;
        this.animateScore(this.score);

        if(this.playerLastScores.length < 10){
          this.playerLastScores.unshift(this.score);
        }else{
          this.playerLastScores.pop(); // remove last element
          this.playerLastScores.unshift(this.score); // store in first element
        }
        this.nbClics++;
        
        this.previousHighScore = this.highScore;
        this.highScore = Math.max.apply(null,this.playerLastScores);
        this.detectHighScoreChanged(this.previousHighScore, this.highScore);
      })
  }

  animateScore(score){
    // Créer un span avec le score, la class l'anime
    const span = this.renderer.createElement('span');
    const text = this.renderer.createText(score);
    this.renderer.addClass(span, 'scoreAnimation');
    this.renderer.appendChild(span, text);
    this.scoresQueue.nativeElement.appendChild(span);
    // Supprimer le span après un interval pour laisser l'animation se terminer
    setInterval(() => {
        this.renderer.removeChild(this.scoresQueue, span);
     }, 2000);
    
  }

  detectHighScoreChanged(previousScore, currentScore){
    if(currentScore > previousScore && previousScore > 0){
      this.notificationService.success('Bravo !', 'Tu viens d\'améliorer ton score !');
    }
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/game/game.component.ts